'use client';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef, useState, useEffect } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from '../DropdownMenu/DropdownMenu.module.scss.js';
import { DropdownMenuItemContent } from './internal/DropdownMenuItemContent.js';

const { componentTestLabel, elementTestLabel } = getTestLabels('DropdownMenuLinkList');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Dropdowns/DropdownMenu/DropdownMenuLinkList.tsx)
 *
 * @param {boolean} autoSort - (optional) Whether or not the items should be alphabetically sorted by label.
 * @param {DropdownMenuLinkListItemProps[]} items - An array of `DropdownMenuLinkListItemProps` items.
 * @param {string} menuId - The menu id (must be unique in the page).
 * @param {boolean} roundedImages - (optional) Whether or not images should be automatically rounded with CSS. Works best with square images. Defaults to false.
 */
const DropdownMenuLinkList = forwardRef((props, ref) => {
    const { autoSort = false, className, items: initialItems, roundedImages, ...otherProps } = props;
    const [items, setItems] = useState(initialItems);
    useEffect(() => {
        if (!autoSort)
            return;
        setItems([...initialItems].sort((a, b) => a.label.localeCompare(b.label)));
    }, [autoSort, initialItems]);
    return (
    // note about the redundant role="list" attribute https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility_concerns
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    jsx("ul", { "data-zta": componentTestLabel, ref: ref, ...otherProps, role: "list", className: classNames(style['z-dropdown-menu-list'], className), children: items.map((item, index) => {
            const { href, image, label, isSelected, options } = item;
            return (jsx("li", { "data-zta": elementTestLabel('Item'), className: style['z-dropdown-menu-list__item'], children: jsx("a", { href: href, "data-zta": elementTestLabel('Anchor'), className: classNames(style['z-dropdown-menu-list__anchor'], style['z-dropdown-menu-list__item-wrap']), tabIndex: 0, children: jsx(DropdownMenuItemContent, { image: image, isSelected: isSelected, label: label, options: options, roundedImages: roundedImages }) }) }, index));
        }) }));
});
DropdownMenuLinkList.displayName = 'DropdownMenuLinkList';

export { DropdownMenuLinkList };
//# sourceMappingURL=DropdownMenuLinkList.js.map
